import React from 'react'
import { CDBBtn, CDBIcon, CDBBox} from 'cdbreact';
import styled from 'styled-components';
import './footer.css'
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade';

const SectionFooter = styled.section`
width: 100%;
padding:1rem 0;
color: gold;
margin-bottom: 0;
background-color: #0f2c3c;
`;

const Footer = () => {
  return (
    <SectionFooter  style={{overflow:'hidden'}}>
      <Fade bottom >
     <CDBBox display="flex" flex="column" className="mx-auto">
      <CDBBox display="flex" justifyContent="center" className="flex-wrap footer-flex">
        <CDBBox alignSelf="center" >
          <CDBBox className="mt-2" display="flex ">
            <Link style={{textDecoration:"none"}} to="https://www.facebook.com/anjanikumarbhatnagar?mibextid=ZbWKwL " target='_blank'>
            <CDBBtn flat color="dark" className="p-2">
              <CDBIcon fab icon="facebook-f"className='g' />
            </CDBBtn>
              </Link>           
            <Link style={{textDecoration:"none"}} to="https://wa.me/+919899995055" target='_blank'>
            <CDBBtn flat color="dark" className="mx-3  p-2">
              <CDBIcon fab icon="whatsapp" className='g' />
            </CDBBtn>
              </Link>
              <Link style={{textDecoration:"none"}} to="https://www.instagram.com/anjanikumarbhatnagar?igsh=aXF2dmJtc2l4ZWV1" target='_blank'>
            <CDBBtn flat color="dark" className="p-2 ">
              <CDBIcon fab icon="instagram"  className='g'/>
            </CDBBtn>
              </Link>
              <Link style={{textDecoration:"none"}} to="https://www.linkedin.com/in/anjanikumarbhatnagar?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app " target='_blank' >
            <CDBBtn flat color="dark" className=" mx-3 p-2 ">
              <CDBIcon fab icon="linkedin"  className='g'/>
            </CDBBtn>
              </Link>
          </CDBBox>
        </CDBBox>
     
      
        {/* <CDBBox>
          <p className="h5 mb-4" style={{ fontWeight: '600', textAlign: 'left' }}>
            Contact us
          </p>
          <CDBBox marginLeft = '1rem' display="flex" flex="column" style={{ cursor: 'pointer', textAlign: 'left' }}>
            <CDBNavLink path="/"><i class="ri-phone-fill"></i>Phone</CDBNavLink>
            <CDBNavLink path="/">Email</CDBNavLink>
            <CDBNavLink path="/">Address</CDBNavLink>
          </CDBBox>
        </CDBBox> */}
      </CDBBox>
      <small className="text-center mt-2">&copy; Dr. Anjani Kumar Bhatnagar, 2024 - 2025. All rights reserved. Developed by SOFTIWO</small>
      {/* <small className="text-center mb-5">Developed by: <Link style={{textDecoration:"none"}} to="https://linkedin.com/in/deveshjain0304"> Devesh Jain</Link> </small> */}
    </CDBBox>
    </Fade>
    
  </SectionFooter>
  )
}

export default Footer